package com.karawek.core.ui.haptics

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
actual object CoreHaptics {
    actual fun perform(type: HapticType) {
        // No-op for now
    }
}
